import * as React from 'react'
import { useTranslation } from 'react-i18next'
import Pagination from '@mui/material/Pagination'
import { styled } from '@mui/material/styles'
import './hrPagination.css'

const StyledPagination = styled(Pagination)(({ theme }) => ({
	'& .MuiPaginationItem-root': {
		color: '#AAB8D1',
		height: '32px',
		fontSize: '12px',
		lineHeight: '16px',
	},
	'& .Mui-selected': {
		backgroundColor: '#17B67C !important',
		color: '#FFFFFF !important',
	},
	'& .MuiPaginationItem-previousNext': {
		'&::after': {
		},
	},
}))

export const HrPagination = ({
	numberOfElements, //количество элементов на странице отображено сейчас
	totalPages, //общее количество страниц
	totalElements, //общее количество элементов
	handleChangePage, //переключение страницы
	handleChangeRowsPerPage, //смена количества элементов на страницу
	rowsPerPageitems, //список количество элементов на одну страницу
	rowsPerPage, //количество элементов на одну страницу
	page,
	noMarginBottom,
	className,
}) => {
	const { t } = useTranslation()

	return (
		<div className={`hr-pagination-wrapper ${noMarginBottom ? 'margin-bottom-zero' : ''} ${className}`}>
			<div className="hr-pagination-left">
				<div className="content-show-per-page">{t('pagination.show_per_page_text')}:</div>
				{rowsPerPageitems.map((item) => (
					<div
						key={item.label}
						className={`content-button-per-page ${rowsPerPage === item.size ? 'content-button-per-page-active' : ''}`}
						onClick={() => handleChangeRowsPerPage(item.size)}
					>
						{item.size != null ? item.label : t(item.label)}
					</div>
				))}
				<div className="content-button-per-page"> | </div>
				<div className="content-button-per-page-count">
					{t('pagination.showed')} {numberOfElements || 0} {t('pagination.from')} {totalElements || 0}
				</div>
			</div>
			<div className="hr-pagination-right">
				{/* Используем наш стилизованный компонент */}
				<StyledPagination
					disabled={totalPages === 0}
					count={totalPages || 1}
					onChange={handleChangePage}
					page={page + 1}
					shape="rounded"
				/>
			</div>
		</div>
	)
}
